import React, { useState, useCallback, useEffect, useRef, FormEvent } from "react";
import { useApi } from "../../../hooks/api";
import { Container, ContainerButtons, ContainerIDescription, ContainerIntegrationLogo, Content, ContentFirstStep, Form } from "./style";
import { useGlobal } from "../../../hooks/global";
import { ModalHeader } from "../../../components/ModalHeader";
import { ModalGeneric } from "../../../components/ModalGeneric";
import { ContentOrLoading } from "../../../components/Loadings/ContentOrLoading";
import { IGroupProps } from "../../../interfaces";
import { useForm } from "react-hook-form";
import { GenericForm, IGenericFormRefProps } from "../../../components/GenericForm";
import Button from "../../../components/Buttons/Button";
import { activeItens, secondary } from "../../../theme";
import staysIcon from "./../../../assets/stays.svg";
import { Flex } from "@mantine/core";
import { apiUrlMagikey } from "../constants/apiUrlMagikey";
import { FaRegArrowAltCircleRight } from "react-icons/fa";

interface IModalMagikeyConection {
    onCancel: Function
    onSave: Function
    defaultId?: string
}

export const ModalStaysConection: React.FC<IModalMagikeyConection> = (props) => {
    const { onCancel, onSave, defaultId } = props

    const { api, setUser, user } = useApi()
    const { theme, notify } = useGlobal()

    const [loading, setLoading] = useState(false);
    //const [stepCreateIntegration, setStepCreateIntegration] = useState(!defaultId ? 1 : 2);
    const [stepCreateIntegration, setStepCreateIntegration] = useState(!defaultId ? 1 : 2);

    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
        setError,
        setValue,
        watch,
        trigger
    } = useForm({
        mode: "all",
    });

    const _form = watch();

    const form_ref = useRef<IGenericFormRefProps>(null);
    const submitButtonRef = useRef<HTMLButtonElement>(null);

    const searchIntegration = useCallback(async () => {
        if (defaultId) {
            setLoading(true);
            try {
                const { data } = await api.get(`/integrations/${defaultId}`);

                Object.entries(data).forEach(([key, value]) => {
                    setValue(key, value);
                });

            } catch (err) {
                notify("Erro ao buscar a integração", "error");
                onCancel();
            }
        }

        setLoading(false);
    }, [defaultId, setValue]);

    const onSubmit = useCallback(async () => {
        setLoading(true);

        const api_url = _form?.api_url;
        const api_username = _form?.api_username;
        const api_password = _form?.api_password;
        const type = 'STAYS';
        const active = true;

        try {
            await api.post("/integrations", {
                api_url,
                api_username,
                api_password,
                type,
                active
            })

            notify('Dados da integração com Stays salvos com sucesso!', "success");

            onSave();

            setUser({ ...user, integration_stays_active: true })

        } catch (err: any) {
            const error = err.response ? err.response?.data : "SERVER ERROR";

            if (error?.field === 'api_key') {
                notify(error?.detail, "alert");
                setLoading(false);
                return;
            }

            if (error?.field === 'api_url') {
                notify(error?.detail, "alert");
                setLoading(false);
                return;
            }

            if (error?.field) {
                setError(error.field, { type: "manual", message: error.detail });
            } else {
                notify('Erro ao salvar informações da integração com Stays, tente novamente mais tarde!', "alert");
            }
        }

        setLoading(false);
    }, [api, errors, _form]);

    const handleStopPropagation = useCallback(
        (e: FormEvent<HTMLFormElement>) => {
            e?.stopPropagation();
            handleSubmit(onSubmit)(e);
        },
        [handleSubmit, onSubmit, form_ref, _form, api]
    );

    const groups: IGroupProps[] = [
        {
            name: "",
            label: "",
            fields: [
                [
                    {
                        name: "api_url",
                        label: "Api URL",
                        type: "input",
                        required: true,
                    },
                ],
                [
                    {
                        name: "api_username",
                        label: "Nome de usuário da api",
                        type: "input",
                        required: true,
                    },
                ],
                [
                    {
                        name: "api_password",
                        label: "Senha da api",
                        type: "input",
                        required: true,
                        isPassword: true,
                    },
                ],
            ],
        },
    ];

    useEffect(() => {
        searchIntegration();
    }, [defaultId]);

    return (
        <ModalGeneric open onClose={() => { }}>
            <Container theme={theme}>
                <ModalHeader
                    title={"Integração com a Stays"}
                    subTitle={"Informe os dados necessárias para realizar integração com a Stays"}
                    onCancel={() => onCancel()}
                    theme={theme}
                />

                {stepCreateIntegration === 1 && (
                    <ContentFirstStep>
                        <ContainerIntegrationLogo>
                            <img src={staysIcon} alt="Stays" style={{ width: 30, objectFit: "contain" }} />
                            Stays
                        </ContainerIntegrationLogo>

                        <ContainerIDescription>
                            👋 Bem-vindo à integração Stays + WebCheckin.app!
                            Agora sua operação de hospedagem vai ficar ainda mais automatizada, segura e eficiente.
                            <br />
                            <br />
                            Com a integração entre o Stays e o WebCheckin.app, você poderá:
                            <br />
                            <br />
                            ✅ Importar automaticamente suas reservas para o sistema de check-in; <br />
                            ✅ Disparar mensagens automáticas via WhatsApp ou e-mail com instruções personalizadas; <br />
                            ✅ Solicitar documentos dos hóspedes com biometria facial (face-match); <br />
                            ✅ Enviar chaves eletrônicas ou códigos de acesso diretamente ao hóspede; <br />
                            ✅ Notificar automaticamente a portaria ou condomínio sobre novas entradas. <br />
                            <br />
                            <br />
                            🚀 Pronto para ativar a integração?
                            Conecte sua conta Stays e comece a oferecer uma experiência de check-in mais inteligente, ágil e profissional aos seus hóspedes.
                            <br />
                            <br />
                            👉 Clique em “Iniciar” para configurar.
                            {/*  <br />
                            <br />
                            Com a integração entre o <b>Magikey</b> e o <b>WebChecki.app</b>, você gerencia autorizações
                            e acessos de forma automática e segura. Controle suas portas,
                            defina permissões personalizadas e acompanhe tudo em tempo real –
                            de qualquer lugar do mundo.
                            <br />
                            <br />
                            Menos burocracia, mais eficiência. Tudo conectado, tudo na nuvem.
                            <br />
                            <br />
                            Está pronto para transformar a gestão do seu espaço? 🚀 */}
                        </ContainerIDescription>

                        <Flex justify='flex-end'>
                            <Button
                                onClick={() => setStepCreateIntegration(2)}
                                background={secondary[theme]}
                                color={"#FFF"}
                                style={{ padding: 8, fontSize: 14, marginTop: 10, marginBottom: 15 }}
                                children={"INICIAR"}
                            />
                        </Flex>
                    </ContentFirstStep>
                )}

                {stepCreateIntegration === 2 && (
                    <ContentOrLoading loading={loading} theme={theme} type="wave">
                        <Content>
                            <ContainerIntegrationLogo>
                                <img src={staysIcon} alt="Stays" style={{ width: 30, objectFit: "contain" }} />
                                Stays
                            </ContainerIntegrationLogo>

                            <ContainerIDescription>
                                <div style={{ fontSize: '18px', fontWeight: 600, paddingBottom: 6 }}>Dados de Acesso</div>
                                Para realizar a integração, é necessário que você acesse o painel da Stays para copiar os dados.
                                        <a
                                    href="https://youtu.be/IBRaY9MNRro"
                                    target="_blank"
                                    style={{ textDecoration: 'none', color: activeItens[theme], padding: '0 5px' }}
                                >
                                    Clique aqui
                                </a>
                                para assistir ao passo a passo de como pegar os dados para integração.
                            </ContainerIDescription>

                            <Form onSubmit={handleStopPropagation}>
                                <GenericForm
                                    ref={form_ref}
                                    groups={groups}
                                    _form={_form}
                                    control={control}
                                    trigger={trigger}
                                    errors={errors}
                                    setValue={setValue}
                                    register={register}
                                    key={errors?.toString()}
                                />
                                <button
                                    className="display-none"
                                    type="submit"
                                    ref={submitButtonRef}
                                />
                            </Form>
                        </Content>

                        <ContainerButtons theme={theme}>
                            <Button
                                onClick={() => submitButtonRef.current?.click()}
                                background={secondary[theme]}
                                color={"#FFF"}
                                style={{ padding: 8, maxWidth: 150, fontSize: 14 }}
                                children={
                                    <Flex align='center' gap={7}>
                                        Validar Dados

                                        <FaRegArrowAltCircleRight />
                                    </Flex>
                                }
                            />
                        </ContainerButtons>
                    </ContentOrLoading>
                )}
            </Container>
        </ModalGeneric>
    )
}